import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-491aaf38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }

import { onUnmounted, ref, watch } from 'vue'

interface Props {
  borderStyle?: string
  vertical?: boolean
  position?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'divider',
  props: {
    borderStyle: { default: 'solid' },
    vertical: { type: Boolean },
    position: { default: 'center' }
  },
  setup(__props: any) {

const props = __props as { borderStyle: string, vertical?: boolean, position: string }

_useCssVars(_ctx => ({
  "963c3c9c": (props.borderStyle)
}))



const position = ref()

watch(
  () => props.position,
  val => {
    switch (val) {
      case 'left':
        position.value = 'is-left'
        break
      case 'right':
        position.value = 'is-right'
        break
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["u-divider", { vertical: __props.vertical }])
  }, [
    _createElementVNode("fieldset", _hoisted_1, [
      (_ctx.$slots.default || __props.vertical)
        ? (_openBlock(), _createElementBlock("legend", {
            key: 0,
            class: _normalizeClass(["inner", position.value])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})